import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'

const EnhancedTableToolbar = ({ numTotal, numTotalText = 'archivos' }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        '& .MuiTypography-root': {
          color: 'green',
          '& span': {
            mr: 0.5,
            fontWeight: 700,
          },
        },
      }}
    >
      <Typography variant="body2">
        <Typography component="span" variant="body1">
          {numTotal}
        </Typography>
        {numTotalText}
      </Typography>
    </Box>
  )
}

EnhancedTableToolbar.propTypes = {
  numTotal: PropTypes.number,
  numTotalText: PropTypes.string,
}

export default EnhancedTableToolbar
